export default __webpack_public_path__ + "static/media/petipota.86d710a9.png";